import { PoweredBy } from "./PoweredBy";

type Props = {
  onStart: () => void;
  hasSaved: boolean;
  onClearSaved: () => void;
};

export function Welcome({ onStart, hasSaved, onClearSaved }: Props) {
  return (
    <div className="welcome section-anim">
      <img className="welcome-logo" src={`${import.meta.env.BASE_URL}upside-logo.png`} alt="Upside Youth Mentoring" />
      <h1>Become an Upside Mentor</h1>
      <p style={{ color: "var(--muted)", fontSize: 16 }}>
        Thanks for your interest in becoming an Upside mentor. This application helps us get to know you so we can match you with the right young person.
      </p>
      <p style={{ color: "var(--muted)", fontSize: 15 }}>
        The programme runs online for ten weeks on a consistent day and time. Your answers save automatically as you go.
      </p>
      <div className="meta">
        <span>🕐</span>
        <span>About 10–15 minutes</span>
      </div>
      <div>
        <button className="btn btn-primary" onClick={onStart}>
          {hasSaved ? "Continue your application" : "Start application"}
        </button>
      </div>
      {hasSaved && (
        <div style={{ marginTop: 16 }}>
          <button
            className="btn btn-ghost"
            onClick={onClearSaved}
            style={{ fontSize: 14, padding: "10px 16px" }}
          >
            Clear saved answers and start fresh
          </button>
        </div>
      )}
      <PoweredBy />
    </div>
  );
}
